import { useJobHeartbeat as useJobHeartbeatMutation } from "@/api";
import { useEffect } from "react";
import { JOB_HEARTBEAT_INTERVAL_IN_MS } from "../assets/jobHeartbeat";

interface Props {
  jobId: string;
  activateHeartbeat: boolean;
}

export function useJobHeartbeat({ jobId, activateHeartbeat }: Props) {
  const [heartbeat] = useJobHeartbeatMutation(jobId);

  useEffect(() => {
    if (!activateHeartbeat) return undefined;

    const interval = setInterval(heartbeat, JOB_HEARTBEAT_INTERVAL_IN_MS);

    return () => clearInterval(interval);
  }, [activateHeartbeat, heartbeat]);
}
